import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const NavArrowRightSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.15188 25.0345C9.14653 24.4063 9.39142 23.7995 9.83715 23.3366L17.1216 15.9999L9.83715 8.66312C9.39084 8.20159 9.14307 7.59694 9.14307 6.96933C9.14307 6.34172 9.39084 5.73707 9.83715 5.27554C10.0506 5.0536 10.3102 4.87637 10.5993 4.75514C10.8885 4.6339 11.201 4.57129 11.5169 4.57129C11.8328 4.57129 12.1453 4.6339 12.4345 4.75514C12.7237 4.87637 12.9832 5.0536 13.1967 5.27554L22.1601 14.3069C22.6082 14.7666 22.8574 15.3708 22.8574 15.9982C22.8574 16.6257 22.6082 17.2299 22.1601 17.6896L13.2053 26.7242C12.9918 26.9461 12.7322 27.1234 12.4431 27.2446C12.1539 27.3658 11.8414 27.4284 11.5255 27.4284C11.2096 27.4284 10.8971 27.3658 10.6079 27.2446C10.3187 27.1234 10.0592 26.9461 9.84571 26.7242C9.40054 26.2642 9.15556 25.6602 9.16044 25.0345"
        fill={fill}
      />
    </svg>
  </span>
);

export default NavArrowRightSVG;
